/**
 * Constructor for ajax loaded components.
 * @constructor
 * @extends {Foundation.Component}
 * @param {string} id The component identifier string. Can contain a path
 *                    followed by a colon, then the identifier string if
 *                    this component is to be loaded ajaxily.
 * @param {Object.<string,*>=} parameters
 */
Foundation.Component.Ajax = function (id, parameters) {
    // Parse the ajaxable ID string.
    var parts = id.match(/^((?:GET|POST)? ?)(\/[^:]+):(\w+)$/);
    if (parts) {
        id = parts[3];
        this.method = parts[1] || "GET";
        this.url = parts[2];
        this.parameters = parameters || {};
    }
    else {
        this.url = window.location.toString().replace(/\?.*/, "");
        var params = Foundation.URL.parseQueryString(window.location.search.substring(1));
        this.parameters = Foundation.extend(params, parameters);
    }

    // Run component constructor.
    Foundation.Component.call(this, id);

    // If we are not fulfilled, then we need to do an Ajax request right now.
    if (this.isIncomplete()) {
        this.doAjax();
    }
};
Foundation.inherit(Foundation.Component.Ajax, Foundation.Component);

/**
 * Perform the ajax request.
 * @protected
 * @param {Object.<string,*>=} parameters
 */
Foundation.Component.Ajax.prototype.doAjax = function (parameters) {
    var xhr = jQuery.ajax(this.ajaxOptions(parameters));

    xhr.done((function (data, status, xhr) {
        this.setXJSON(xhr);
        this.setView(jQuery(data));
    }).bind(this));

    xhr.fail((function () {
        this.fail();
    }).bind(this));
};

/**
 * Update the xJSON member object with the value from the response.
 * @param xhr {jQuery.jqXHR}
 */
Foundation.Component.Ajax.prototype.setXJSON = function (xhr) {
    var jsonData = xhr.getResponseHeader("X-JSON");
    if (jsonData) {
        try {
            /**
             * @type {Object}
             */
            this.xJSON = jQuery.parseJSON(jsonData);
        }
        catch (e) {
            Foundation.warn("Error parsing X-JSON", e, jsonData);
            this.fail();
        }
    }
};

/**
 * Get the options to pass to jQuery.ajax().
 * @protected
 * @param {Object.<string,*>=} parameters
 * @return {Object.<string,*>}
 */
Foundation.Component.Ajax.prototype.ajaxOptions = function (parameters) {
    parameters = Foundation.extend(this.parameters, parameters);
    parameters["ajaxComponent"] = this.id;
    return {
        "url": this.url,
        "type": this.method,
        "data": parameters
    };
};

/**
 * Update the contents of the component with the result of calling the
 * component with different parameters.
 * @param {Object.<string,*>=} parameters
 * @return {Foundation.Promise}
 */
Foundation.Component.Ajax.prototype.update = function (/* parameters */) {
    // XXX
};
